<template>
  <div class="eval-dashboard">
    <div class="eval-breadcrumb">
      <el-link :underline="false" type="primary" @click="backToList">评测列表</el-link>
      <template v-if="activeView !== 'list'">
        <span class="sep">/</span>
        <el-link v-if="activeView === 'drilldown'" :underline="false" type="primary" @click="backToDetail">
          Run {{ selectedRunId }}
        </el-link>
        <span v-else class="current">Run {{ selectedRunId }}</span>
      </template>
      <template v-if="activeView === 'drilldown'">
        <span class="sep">/</span>
        <span class="current">样本 {{ selectedSampleKey }}</span>
      </template>
    </div>

    <EvalRunList v-if="activeView === 'list'" @select-run="goToDetail" />
    <EvalRunDetail
      v-else-if="activeView === 'detail'"
      :run-id="selectedRunId"
      @select-sample="goToDrilldown"
    />
    <EvalSampleDrilldown
      v-else
      :run-id="selectedRunId"
      :sample-key="selectedSampleKey"
      :pipeline-mode="selectedPipelineMode"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import EvalRunList from './EvalRunList.vue';
import EvalRunDetail from './EvalRunDetail.vue';
import EvalSampleDrilldown from './EvalSampleDrilldown.vue';

// 'list' | 'detail' | 'drilldown' —— 无 vue-router，局部状态切换三视图（对齐设计文档第五节）
const activeView = ref('list');
const selectedRunId = ref(null);
const selectedSampleKey = ref(null);
// run.pipeline_mode，随「下钻」跳转一并透传给 EvalSampleDrilldown（'three_stage' | 'single'）
const selectedPipelineMode = ref('three_stage');

const goToDetail = (runId) => {
  selectedRunId.value = runId;
  selectedSampleKey.value = null;
  activeView.value = 'detail';
};

const goToDrilldown = (sampleKey, pipelineMode) => {
  selectedSampleKey.value = sampleKey;
  selectedPipelineMode.value = pipelineMode || 'three_stage';
  activeView.value = 'drilldown';
};

const backToList = () => {
  activeView.value = 'list';
  selectedRunId.value = null;
  selectedSampleKey.value = null;
};

const backToDetail = () => {
  if (activeView.value !== 'drilldown') return;
  activeView.value = 'detail';
  selectedSampleKey.value = null;
};
</script>

<style scoped>
.eval-breadcrumb {
  margin-bottom: 16px;
  font-size: 14px;
  color: #606266;
}

.eval-breadcrumb .sep {
  margin: 0 8px;
  color: #c0c4cc;
}

.eval-breadcrumb .current {
  color: #303133;
  font-weight: bold;
}
</style>
